
import React, { forwardRef, useEffect } from "react"
import styled, { css } from "styled-components"

import { useStore } from "../zustandStore"

const CircleSVG = forwardRef((props, ref) => {
  const visible = props.visible == null ? true : props.visible
  const disableBlinking = useStore((state) => state.publicAppSettings.blinkingAnimations === false)
  return (
    <SVGWrapper disableBlinking={disableBlinking} ref={ref} visible={visible} className={`${disableBlinking ? '' : 'blinking blink-0 '}` + props.className + (props.visible ? ' visible' : '')}>
      <svg color={props.color} width={props.width || '0.6em'} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 122.88 122.88">
        <g>
          <path className="st0" d="M61.44,0c33.93,0,61.44,27.51,61.44,61.44s-27.51,61.44-61.44,61.44S0,95.37,0,61.44S27.51,0,61.44,0L61.44,0z"/>
        </g>
      </svg>
    </SVGWrapper>
  )
})

export default CircleSVG

const SVGWrapper = styled.div`
  svg {
    --color: ${props => props.color || '#e23333'};
    enable-background:new 0 0 122.88 122.88;
    .st0{fill-rule:evenodd;clip-rule:evenodd;fill:var(--color);}

    transition-property: opacity;
    transition-duration: 350ms;

    ${props => props.visible ? css`
      opacity: 1;
    ` : css`
      opacity: 0;
    `}
    scale: 90%; // idk this just fixes weird cutoffs that happen sometimes
  }


  transition-property: opacity;
  ${props => props.disableBlinking
    ? css`
      opacity: 0.9;
      transition-duration: 500ms;
      ` : css`
      opacity: 0.6;
      transition-duration: 1750ms;
      &.blink-on { opacity: 0.85; }
      &.blink-off { opacity: 0.35; }
    `
  }


  align-self: center;
  line-height: 0;

  ${'' /* &.blinking { */}
    ${'' /* animation: blink;
    animation-iteration-count: infinite;
    animation-duration: 3s; */}
  ${'' /* @keyframes blink { */}
    ${'' /* 0% { opacity: 0.35; } */}
    ${'' /* 38% { opacity: 1; } */}
    ${'' /* 50% { opacity: 0.85; } */}
    ${'' /* 88% { opacity: 0; } */}
    ${'' /* 100% { opacity: 0.35; } */}
  ${'' /* }  */}
`
